import { api } from "@/shared/api/baseApi";
import type {
  CreateOrganizationBody,
  ListOrganizationsResponse,
  OrganizationResponse,
  UpdateOrganizationBody,
} from "@keystone/contracts/organizations";

const organizationsApi = api
  .enhanceEndpoints({ addTagTypes: ["Organization", "TempAccess"] })
  .injectEndpoints({
    endpoints: (build) => ({
      listOrganizations: build.query<ListOrganizationsResponse, void>({
        query: () => ({ url: "/organizations" }),
        providesTags: (result) =>
          result
            ? [
                ...result.items.map(({ id }) => ({ type: "Organization" as const, id })),
                { type: "Organization", id: "LIST" },
              ]
            : [{ type: "Organization", id: "LIST" }],
      }),

      createOrganization: build.mutation<OrganizationResponse, CreateOrganizationBody>({
        query: (body) => ({ url: "/organizations", method: "POST", body }),
        invalidatesTags: [
          { type: "Organization", id: "LIST" },
          { type: "TempAccess", id: "OPTIONS" },
        ],
      }),

      updateOrganization: build.mutation<
        OrganizationResponse,
        { id: string; body: UpdateOrganizationBody }
      >({
        query: ({ id, body }) => ({ url: `/organizations/${id}`, method: "PATCH", body }),
        invalidatesTags: (_result, _error, { id }) => [
          { type: "Organization", id },
          { type: "Organization", id: "LIST" },
          { type: "TempAccess", id: "OPTIONS" },
        ],
      }),
    }),
  });

export const {
  useListOrganizationsQuery,
  useCreateOrganizationMutation,
  useUpdateOrganizationMutation,
} = organizationsApi;
export { organizationsApi };
